import { Button, Dialog, FormControlLabel, styled, Switch, SwitchProps, TextField } from "@mui/material"
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import {ProjectConfig} from 'Global';
import { useSnackbar, withSnackbar } from "notistack";
import ISwitch from "elements/ISwitch";
import ic_packages from 'icons/ic_packages.svg';


export default function PlanEditor(props : any) {

  /*=============================================
  VARIABLES FROM PROPS
  ============================================= */
  const {
    setLoading, 
    openEditor, 
    setOpenEditor, 
    plan_id,
    loadList,
    level = ""
  } = props;


  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /*============================================= 
      plan_id,
    plan_name,
    price_monthly,
    price_yearly,
    description,
    short_description,
    features,
    plan_level,
    status
    */

  const defaultValues: any = {
    plan_id: plan_id? plan_id : "null",
    plan_name: "",
    status: false,
    price_monthly: 0,
    price_yearly: 0,
    description: "",
    short_description: "",
    features: [],
    plan_level: 0,
    
  };
  
  const [formValues, setFormValues] = useState(defaultValues)
  const [showErrors, setShowErrors] = useState(false);



  /*=======================================
  GET USER DETAILS IF USER_ID EXISTS
  =======================================*/
  useEffect(() => {
    if (plan_id && openEditor) {
      axios.get(ProjectConfig.api_url + "/plans/details", {
          params: {
            plan_id: plan_id,
          },
        })
        .then((response) => {
          console.log("formValues res", response.data)
          setFormValues(response.data);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    }
    else{
      setFormValues(defaultValues);
    }
    
  } , [plan_id, openEditor])




  /*=======================================
  HANDLE INPUT CHANGE
  =======================================*/
  const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };


  /*=======================================
  SUBMIT FUNCTION
  =======================================*/
  const handleSubmit = () => {
    if (!formValues.plan_name.trim()) {
      setShowErrors(true);
      enqueueSnackbar("Complete all fields", { variant: 'error' });
      return;
    }
    if (formValues.plan_level === "") {
      setShowErrors(true);
      enqueueSnackbar("Complete all fields", { variant: 'error' });
      return;
    }
    if (formValues.price_monthly === "") {
      setShowErrors(true);
      enqueueSnackbar("Complete all fields", { variant: 'error' });
      return;
    }
    if (formValues.price_yearly === "") {
      setShowErrors(true);
      enqueueSnackbar("Complete all fields", { variant: 'error' });
      return;
    }
    setLoading(true);
    
    axios.post(ProjectConfig.api_url+"/plans/addedit", formValues,
      {
        headers: {
          // 
        },
      })
      .then((response) => {
        console.log(response.data);

        if(response.data.status === "success"){
          enqueueSnackbar('Success', { variant: 'success' });
          setFormValues(defaultValues);
          setOpenEditor(false);
          loadList();
          
        }else{
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
          
      })
      .catch((err) => {
        console.log(err.response.data);
      }).
      finally(() => {
        setLoading(false);
      });  
  };



  return (
      <>
        <Dialog 
          open={openEditor}
          onClose={() => {
            setOpenEditor(false);
            setFormValues(defaultValues);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          PaperProps={{ sx: { borderRadius: "20px" } }}
        >
          <div className="DialogContainer">
              <div className="ModuleWrapper">
                <div className="boxContainerHeader">
                  <div className="dialog_container_title">
                      <h2 className="dialog_title"><img src={ic_packages}/>
                        {plan_id ? "Edit Package" : "Add Package"}
                      </h2>
                      
                      <h3 className="dialog_subtitle">Package</h3>
                  </div>
                </div>

                <div className="dialogFormContainer">
                  <div className='input_group'>

                      <TextField
                        id="plan_name"
                        name="plan_name"
                        label="Package Name"
                        type="text"
                        required
                        fullWidth
                        value={formValues.plan_name}
                        onChange={handleInputChange}
                        error={showErrors && !formValues.plan_name.trim()}
                        helperText={showErrors && !formValues.plan_name.trim() ? "Campo requerido" : ""}
                      />

                      <TextField
                        id="plan_level"
                        name="plan_level"
                        label="Level"
                        type="number"
                        required
                        fullWidth
                        value={formValues.plan_level}
                        onChange={(e: any) => {
                          setFormValues({
                            ...formValues,
                            plan_level: e.target.value
                          });
                        }}
                        error={showErrors && formValues.plan_level === ""}
                        helperText={showErrors && formValues.plan_level === "" ? "Campo requerido" : ""}
                      />

                      <h2>Prices</h2>

                      <TextField
                        id="monthly_price"
                        name="monthly_price"
                        label="Monthly Price"
                        type="number"
                        required
                        fullWidth
                        value={formValues.price_monthly}
                        onChange={(e: any) => {
                          setFormValues({
                            ...formValues,
                            price_monthly: e.target.value
                          })
                        }
                        }
                        error={showErrors && formValues.price_monthly === ""}
                        helperText={showErrors && formValues.price_monthly === "" ? "Campo requerido" : ""}
                      />
                          

                      <TextField
                        id="yearly_price"
                        name="yearly_price"
                        label="Annual Price"
                        type="number"
                        required
                        fullWidth
                        value={formValues.price_yearly}
                        onChange={(e: any) => {
                          setFormValues({
                            ...formValues,
                            price_yearly: e.target.value
                          });
                        }}
                        error={showErrors && formValues.price_yearly === ""}
                        helperText={showErrors && formValues.price_yearly === "" ? "Campo requerido" : ""}
                      />

                      <TextField
                        id="short_description"
                        name="short_description"
                        label="Short Description"
                        type="text"
                        fullWidth
                        value={formValues.short_description}
                        onChange={(e: any) => {
                          setFormValues({
                            ...formValues,
                            short_description: e.target.value
                          });
                        }}
                      />

                      <TextField
                        id="description"
                        name="description"
                        label="Description"
                        type="text"
                        multiline
                        rows={4}
                        value={formValues.description}
                        onChange={(e: any) => {
                          setFormValues({
                            ...formValues,
                            description: e.target.value
                          });
                        }}
                      />

                  </div>

                  <ISwitch
                      label={formValues.status ? "Active" : "Inactive"}
                      checked={formValues.status}
                      name="modules"
                      //purple color
                      switchColor="#7B1FA2"
                      onChange={(e: any) => {
                        setFormValues({
                          ...formValues,
                          status: e.target.checked
                        });
                      }} 
                    />
              
                </div>
              </div>
          </div>

          <div className="dialogButtons">

            <Button onClick={handleSubmit} variant="contained" className="button_1">Save Changes</Button>

            <Button
                onClick={() => {
                  setOpenEditor(false);
                  setFormValues(defaultValues);
                }}
                variant="contained"
                color="secondary"
                className="button_secondary"
            >
              Cancel
            </Button>

            
          </div>

        </Dialog>
      </>
  );
}
